import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-network-status-banner',
    standalone: true,
    imports: [CommonModule],
    template: `
        @if (showBanner) {
            <div
                    class="banner"
                    [ngClass]="{
        'banner-offline': !isOnline,
        'banner-online': isOnline && wasOffline
      }"
                    [@slideInOut]="showBanner ? 'in' : 'out'">

                <div class="banner-content">
                    <div class="icon">
                        @if (!isOnline) {
                            <ng-container>
                                <svg width="20" height="20" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18 17.94 6M18 18 6.06 6"/>
                                </svg>
                            </ng-container>
                        }
                        @if (isOnline && wasOffline) {
                            <ng-container>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                     stroke-width="2">
                                    <polyline points="20,6 9,17 4,12"/>
                                </svg>
                            </ng-container>
                        }
                    </div>

                    <span class="message">
          {{ isOnline ? 'Connection restored' : 'No internet connection' }}
        </span>
                </div>
            </div>
        }
    `,
    styles: [`
    .banner {
      //position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9999;
      padding: 12px 16px;
      color: white;
      font-size: 14px;
      font-weight: 500;
      //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease-in-out;
    }

    .banner-offline {
      background-color: #dc3545;
    }

    .banner-online {
      background-color: #28a745;
    }

    .banner-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      max-width: 1200px;
      margin: 0 auto;
    }

    .icon {
      display: flex;
      align-items: center;
    }

    .message {
      line-height: 1;
    }

    /* Animation classes */
    .banner.ng-enter {
      transform: translateY(-100%);
      opacity: 0;
    }

    .banner.ng-enter-active {
      transform: translateY(0);
      opacity: 1;
      transition: all 0.3s ease-in-out;
    }

    .banner.ng-leave {
      transform: translateY(0);
      opacity: 1;
    }

    .banner.ng-leave-active {
      transform: translateY(-100%);
      opacity: 0;
      transition: all 0.3s ease-in-out;
    }

    /* Responsive adjustments */
    @media (max-width: 768px) {
      .banner {
        padding: 10px 12px;
        font-size: 13px;
      }
    }
  `],
    animations: []
})
export class NetworkStatusBannerComponent implements OnInit, OnDestroy {
    isOnline: boolean = navigator.onLine;
    showBanner: boolean = false;
    wasOffline: boolean = false;
    private hideTimeout?: number;

    ngOnInit() {
        // Listen for online/offline events
        window.addEventListener('online', this.onOnline.bind(this));
        window.addEventListener('offline', this.onOffline.bind(this));

        // Show banner immediately if offline
        if (!this.isOnline) {
            this.showOfflineBanner();
        }
    }

    ngOnDestroy() {
        // Clean up event listeners
        window.removeEventListener('online', this.onOnline.bind(this));
        window.removeEventListener('offline', this.onOffline.bind(this));

        // Clear timeout if exists
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
        }
    }

    private onOnline() {
        this.isOnline = true;

        if (this.wasOffline) {
            this.showOnlineBanner();
        }
    }

    private onOffline() {
        this.isOnline = false;
        this.wasOffline = true;
        this.showOfflineBanner();
    }

    private showOfflineBanner() {
        // Clear any existing timeout
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
        }

        this.showBanner = true;
    }

    private showOnlineBanner() {
        this.hideTimeout = window.setTimeout(() => {
            this.showBanner = false;
            this.wasOffline = false;
        }, 3000);
    }
}